import EmployeeWorkInMenu from "./EmployeeWorkInMenu";

import styles from "../styles/Employee.module.css";

function EmployeeWorkIn({ getPage = () => { }, handleMenuChange = () => { } }) {
  return (
    <div className={styles.selector}>
      <EmployeeWorkInMenu onChange={handleMenuChange} />
    </div>
  );
}

export default EmployeeWorkIn;
